import { GTTripV2DriverRsvpStatus } from 'gql/types.generated'
import { defineMessages } from 'react-intl'

export const driverRSVPMessages = defineMessages({
  [GTTripV2DriverRsvpStatus.Confirmed]: {
    id: 'driverRSVP.confirmed',
    defaultMessage: 'Confirmed'
  },
  [GTTripV2DriverRsvpStatus.Declined]: {
    id: 'driverRSVP.declined',
    defaultMessage: 'Declined'
  },
  [GTTripV2DriverRsvpStatus.Failed]: {
    id: 'driverRSVP.failed',
    defaultMessage: 'Failed'
  },
  [GTTripV2DriverRsvpStatus.Missed]: {
    id: 'driverRSVP.missed',
    defaultMessage: 'Missed'
  },
  [GTTripV2DriverRsvpStatus.Sent]: {
    id: 'driverRSVP.sent',
    defaultMessage: 'Sent'
  }
})
